import React from 'react'
import { DumbField } from 'components/Wizard2/Field'
import {
  Checkbox,
  RadioInput,
  TextInput,
  Select,
  FullName,
  NameOrg,
} from 'components/Wizard2/fieldComponents/Form'
import ServerOptions from 'components/Wizard2/fieldComponents/ServerControls'
import MultiComplete from 'components/Wizard2/fieldComponents/MultiComplete'
import DateRange from 'components/Wizard2/fieldComponents/DateRange'
import MountDetector from 'components/MountDetector/MountDetector'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import CaretUpIcon from '@tecuity/sos-icons/react/caret-up'
import SearchIcon from '@tecuity/sos-icons/react/search-heavy'
import { getFirstFocusableScopedElement } from 'utilities'
import { Animate } from 'react-show'

class AdvancedParameters extends React.Component {
  state = {
    optionsCache: {},
    optionGroupsCache: {},
    searchHint: null,
  }
  focusFirstElement = () => {
    const firstElement = getFirstFocusableScopedElement('.search-advanced-animation-wrapper')
    if (firstElement) {
      firstElement.focus()
      const scrollWrapper = document.querySelector('.search-advanced-animation-wrapper')
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0
      }
    }
  }
  toggleAdvanced = () => {
    this.props.onRequestToggleDrawer(undefined, (open) => {
      if (!open && typeof this.props.onClose === 'function') {
        this.props.onClose()
      }
      if (open) {
        this.focusFirstElement()
      }
    })
  }
  hide = () => {
    this.props.onRequestToggleDrawer(false)
  }
  setValue = (value, name, param = {}) => {
    const calculatedValue = param.setValue ? param.setValue(value) : value
    this.props.onChange({
      ...this.props.values,
      [name]: calculatedValue,
    })
  }
  getYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear()
    return Array(currentYear - parseInt(startYear || 1950, 10) + 1)
      .fill(null)
      .map((_, i) => {
        const year = (currentYear - i).toString()
        return { value: year, label: year }
      })
  }
  getOptionsBySrc = (src, param) => {
    switch (src) {
      case 'years':
        return [
          ...(param.preMergeOptions || []),
          ...this.getYearOptions(param.startYear),
          ...(param.postMergeOptions || []),
        ]
      default:
        return []
    }
  }
  getOptionsSrcOverrideValue = (param) => {
    return this.props.values[param.overrideOptionsSrcFromParameterName]
  }
  getSubOptionsSrcOverrideValue = (param) => {
    return this.props.values[param.overrideSubOptionsSrcFromParameterName]
  }
  showDisabledHint = () => {
    this.setState({
      searchHint: 'Please provide valid search criteria to perform a search.',
    })
  }
    render() {
    const { parameters = [], onSearchRequested, searching, startOpen, searchDisabled } = this.props
    const sharedTabIndex = this.props.open ? undefined : '-1'
    return (
      <React.Fragment>
        <Animate
          show={this.props.open}
          duration={350}
          transitionOnMount={startOpen ? false : true}
          className="search-advanced-animation-wrapper"
          style={{ height: 'auto' }}
          start={{ height: 0 }}
        >
          <div className="search-advanced-parameters-wrapper" aria-hidden={!this.props.open}>
            <div className="search-advanced-parameters wizard">
              <div>
                <div className="clear-wrapper">
                  <h2>Advanced Search</h2>
                </div>
                <MountDetector onMounted={this.focusFirstElement} />
                {parameters.map((rawParam) => {
                  const props =
                    typeof rawParam.getProps === 'function'
                      ? rawParam.getProps(this.props.values)
                      : {}
                  const param = { ...rawParam, ...props }
                  if (param.visible === false) return null

                  switch (param.type) {
                    case 'h3':
                      return <h3 key={param.name}>{param.text}</h3>
                    case 'h4':
                      return <h4 key={param.name}>{param.text}</h4>
                    case 'text':
                      return (
                        <DumbField
                          key={param.name}
                          label={param.label}
                          description={param.description}
                        >
                          <TextInput
                            onChange={(value) => {
                              this.setValue(value, param.name, param)
                            }}
                            value={this.props.values[param.name]}
                            width={param.width || '40%'}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel}
                          />
                        </DumbField>
                      )
                    case 'radio':
                      return (
                        <DumbField
                          key={param.name}
                          label={param.label}
                          description={param.description}
                        >
                          <RadioInput
                            onChange={(value) => {
                              this.setValue(value, param.name, param)
                            }}
                            options={param.options}
                            value={this.props.values[param.name]}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel}
                          />
                        </DumbField>
                      )
                    case 'select':
                      return (
                        <DumbField
                          fieldId={param.name}
                          label={param.label}
                          description={param.description}
                          key={param.name}
                        >
                          <Select
                            fieldId={param.name}
                            onChange={(value) => {
                              this.setValue(value, param.name, param)
                            }}
                            options={param.options}
                            value={this.props.values[param.name]}
                            width={param.width || '40%'}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel}
                          />
                        </DumbField>
                      )
                    case 'checkbox':
                      return (
                        <DumbField className="checkbox" fieldId={param.name} key={param.name}>
                          <Checkbox
                            name={param.name}
                            fieldId={param.name}
                            onChange={(value) => {
                              this.setValue(value, param.name, param)
                            }}
                            value={this.props.values[param.name]}
                            label={param.label}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel}
                          />
                        </DumbField>
                      )
                    case 'dateRange':
                      return (
                        <DumbField
                          className="date-range"
                          label={param.label}
                          description={param.description}
                          key={param.name}
                        >
                          <div className="date-range-wrapper">
                            <DateRange
                              fieldId={param.name}
                              onChange={(value) => {
                                this.setValue(value, param.name, param)
                              }}
                              value={this.props.values[param.name]}
                              label={param.label}
                              startLabel="Start"
                              endLabel="End"
                              tabIndex={sharedTabIndex}
                              ariaLabel={param.ariaLabel}
                            />
                          </div>
                        </DumbField>
                      )
                    case 'serverSelect':
                      return (
                        <DumbField
                          fieldId={param.name}
                          label={param.label}
                          description={param.description}
                          key={param.name}
                        >
                          <ServerOptions
                            fieldId={param.name}
                            controlType="select"
                            ariaLabel={param.ariaLabel}
                            onChange={(value) => {
                              this.setValue(value, param.name, param)
                            }}
                            onBlur={() => {}}
                            value={this.props.values[param.name]}
                            options={this.state.optionsCache[param.name] || []}
                            optionGroups={this.state.optionGroupsCache[param.name] || []}
                            optionsSrc={param.optionsSrc}
                            optionsFetched={!!this.state.optionsCache[param.name]}
                            passFieldToOptionsHandler
                            disabled={
                              !this.state.optionsCache[param.name] ||
                              !this.state.optionsCache[param.name].length
                            }
                            tabIndex={sharedTabIndex}
                            placeholder={param.placeholder || '[Select an option]'}
                            optionsSrcOverrideValue={this.getOptionsSrcOverrideValue(param)}
                            subOptionsSrcOverrideValue={this.getSubOptionsSrcOverrideValue(param)}
                            onOptionsFetchStarted={() => {
                              this.setState((state) => {
                                const {
                                  [param.name]: deletedOpt,
                                  ...optionsCache
                                } = state.optionsCache
                                const {
                                  [param.name]: deletedOptGroup,
                                  ...optionGroupsCache
                                } = state.optionGroupsCache
                                return { optionsCache, optionGroupsCache }
                              })
                            }}
                            onOptionsFetched={(options, optionGroups) => {
                              this.setState((state) => ({
                                optionsCache: {
                                  ...state.optionsCache,
                                  [param.name]: options,
                                },
                                optionGroupsCache: {
                                  ...state.optionGroupsCache,
                                  [param.name]: optionGroups,
                                },
                              }))
                            }}
                          />
                        </DumbField>
                      )
                    case 'ServerMultiComplete':
                      return (
                        <DumbField
                          label={param.label}
                          description={param.description}
                          key={param.name}
                        >
                          <ServerOptions
                            ariaLabel={param.label}
                            controlType="ServerMultiComplete"
                            onChange={(value) => {
                              this.setValue(value, param.name, param)
                            }}
                            onBlur={() => {}}
                            value={this.props.values[param.name]}
                            options={this.state.optionsCache[param.name] || []}
                            optionGroups={this.state.optionGroupsCache[param.name] || []}
                            optionsSrc={param.optionsSrc}
                            optionsFetched={!!this.state.optionsCache[param.name]}
                            passFieldToOptionsHandler
                            tabIndex={sharedTabIndex}
                            disabled={
                              !this.state.optionsCache[param.name] ||
                              !this.state.optionsCache[param.name].length
                            }
                            placeholder={param.placeholder || '[Select an option]'}
                            optionsSrcOverrideValue={this.getOptionsSrcOverrideValue(param)}
                            subOptionsSrcOverrideValue={this.getSubOptionsSrcOverrideValue(param)}
                            onOptionsFetchStarted={() => {
                              this.setState((state) => {
                                const {
                                  [param.name]: deletedOpt,
                                  ...optionsCache
                                } = state.optionsCache
                                const {
                                  [param.name]: deletedOptGroup,
                                  ...optionGroupsCache
                                } = state.optionGroupsCache
                                return { optionsCache, optionGroupsCache }
                              })
                            }}
                            onOptionsFetched={(options, optionGroups) => {
                              this.setState((state) => ({
                                optionsCache: {
                                  ...state.optionsCache,
                                  [param.name]: options,
                                },
                                optionGroupsCache: {
                                  ...state.optionGroupsCache,
                                  [param.name]: optionGroups,
                                },
                              }))
                            }}
                            fieldId={param.name}
                          />
                        </DumbField>
                      )
                    case 'MultiComplete':
                      return (
                        <DumbField
                          label={param.label}
                          description={param.description}
                          fieldId={param.name}
                          key={param.name}
                        >
                          <MultiComplete
                            ariaLabel={param.label}
                            fieldId={param.name}
                            tabIndex={sharedTabIndex}
                            options={
                              param.optionsSrc
                                ? this.getOptionsBySrc(param.optionsSrc, param)
                                : param.options
                            }
                            value={this.props.values[param.name]}
                            onBlur={() => {}}
                            onChange={(value) => {
                              this.setValue(value, param.name, param)
                            }}
                          />
                        </DumbField>
                      )
                    case 'FullName':
                      return (
                        <DumbField
                          label={param.label}
                          description={param.description}
                          fieldId={param.name}
                          key={param.name}
                        >
                          <FullName
                            tabIndex={sharedTabIndex}
                            onBlur={() => {}}
                            onChange={(value) => this.setValue(value, param.name, param)}
                            value={this.props.values[param.name]}
                            fieldId={param.name}
                            classNameMap={{
                              firstName: 'col-sm-5 col-md-5 col-lg-4',
                              middleName: 'col-sm-4 col-md-3 col-lg-3',
                              lastName: 'col-sm-6 col-md-4 col-lg-4',
                            }}
                          />
                        </DumbField>
                      )
                    case 'NameOrg':
                      return (
                        <DumbField
                          label={param.label}
                          description={param.description}
                          fieldId={param.name}
                          key={param.name}
                        >
                          <NameOrg
                            tabIndex={sharedTabIndex}
                            onBlur={() => {}}
                            onChange={(value) => this.setValue(value, param.name, param)}
                            value={this.props.values[param.name]}
                            fieldId={param.name}
                            classNameMap={{
                              firstName: 'col-sm-5 col-md-5 col-lg-4',
                              middleName: 'col-sm-4 col-md-3 col-lg-3',
                              lastName: 'col-sm-6 col-md-4 col-lg-4',
                            }}
                          />
                        </DumbField>
                      )
                    default:
                      return null
                  }
                })}
                <div className="advanced-toolbar">
                  <div className="flex-row">
                    <button
                      className="btn btn-primary btn-raised advanced-search-button"
                      aria-disabled={searching || searchDisabled}
                      onClick={
                        searching || searchDisabled ? this.showDisabledHint : onSearchRequested
                      }
                      tabIndex={sharedTabIndex}
                      aria-busy={searching}
                      aria-invalid={searchDisabled}
                      aria-describedby="search-disabled-hint"
                    >
                      <div className="center">
                        <SearchIcon /> Search
                      </div>
                    </button>
                    <button
                      className="btn clear-button"
                      tabIndex={sharedTabIndex}
                      onClick={this.props.clearFilters}
                    >
                      Clear Filters
                    </button>
                  </div>
                  <p id="search-disabled-hint danger-text" aria-live="polite">
                    {this.state.searchHint ? (
                      <span className="search-disabled-hint">{this.state.searchHint}</span>
                    ) : null}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Animate>
        <div className="flex-row advanced-search-toggle-wrapper">
          <button
            className="advanced-search-toggle"
            aria-expanded={this.props.open}
            onClick={this.toggleAdvanced}
            style={{ transform: `translateY(${this.props.open ? -15 : 0}px)` }}
          >
            <span>{process.env.ID_ADVANCED_SEARCH_LABEL ? 'Advanced Search Options' : 'Advanced'}{this.props.open ? <CaretUpIcon /> : <CaretDownIcon />}</span>
          </button>
        </div>
      </React.Fragment>
    )
  }
}

export default AdvancedParameters



// WEBPACK FOOTER //
// ./src/components/Search/AdvancedParameters.js